import React from "react";

import { useFormatTimestamp } from "./timeFormat";

/**
 * Formatted text of a wall-clock ns instant, as a bare fragment — the shared
 * rendering path for the clickable {@link Timestamp} and the non-clickable
 * {@link InlineTimestamp}, so both track the user's format, precision, and
 * t=0 anchor. Outside a TimestampFormatProvider it renders with the default
 * format and options rather than throwing.
 */
export const FormattedTimestampText: React.FC<{ ns: bigint }> = ({ ns }) => {
  const formatTimestampNs = useFormatTimestamp();
  return <>{formatTimestampNs(ns)}</>;
};
